'use client';

import { useEffect, useState } from 'react';

import {
  AutocutPoster,
  TimelinePoster,
} from '../../../sections/HeroSection/Posters';
import css from '../videos.module.css';

export type CaptionVideoProps = {
  scrollPosition: number;
  onEnded?: () => void;
  loop?: boolean;
  style?: React.CSSProperties;
};

export const CaptionVideo = ({
  scrollPosition,
  onEnded,
  loop = false,
  style,
}: CaptionVideoProps) => {
  const [premiereProEnded, setPremiereProEnded] = useState(false);
  const [autocutEnded, setAutocutEnded] = useState(false);

  useEffect(() => {
    if (premiereProEnded && autocutEnded && onEnded) {
      onEnded();
    }
  }, [premiereProEnded, autocutEnded]);

  return (
    <div key="caption" className={css.container} style={style}>
      <video
        key={`caption-timeline`}
        autoPlay={true}
        className={css.premiereProVideo}
        muted
        poster={TimelinePoster}
        onEnded={() => setPremiereProEnded(true)}
        loop={loop}
        playsInline
      >
        <source src={'/static/captions-ppro.mp4'} type="video/mp4" />
      </video>
      <video
        key={`caption-autocut`}
        autoPlay
        muted
        className={css.autocutVideo}
        style={{
          top: `${-(10 - scrollPosition / 8)}px`,
        }}
        poster={AutocutPoster}
        onEnded={() => setAutocutEnded(true)}
        loop={loop}
        playsInline
      >
        <source src={'/static/captions-autocut.mp4'} type="video/mp4" />
      </video>
    </div>
  );
};
